import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

export const queryString = {
  parse: (search = '') => {
    const result = {}
    search
      .replace(/\?/g, '')
      .split('&')
      .forEach((item) => {
        if (item) {
          const splitItems = item.split('=')
          result[splitItems[0]] = splitItems[1]
        }
      })
    return result
  },
}

export const getPatientIdFromUrl = ({ match, location }) => {
  const search = get(location, 'search', '')
  const pathPatientId = get(match, 'params.patientId', '')
  let patientId = pathPatientId
  if (!isEmpty(search)) {
    const queryParams = queryString.parse(search) || {}
    patientId = queryParams.patientId || pathPatientId
  }
  return patientId
}

export const getQueryParams = ({ match, location }) => {
  const search = get(location, 'search', '')
  if (!isEmpty(search)) {
    return queryString.parse(search)
  }
  return null
}

/**
 * 提取 isActivity 和 fontSize
 * @param {*} path
 */
export const getParams = (path) => {
  const params = path.split("/");
  let result = {};
  for (let i = 1; i < params.length; i++) {
    if (params[i] === "true") {
      result = {
        ...result,
        isActivity: "true",
      };
    }
    if (Number(params[i]) > 0) {
      result = {
        ...result,
        fontSize: params[i],
      };
    }
  }
  return result
};


export const needleImageCdnStart = fileName => `https://cdn.ihealthlabs.com.cn/app/needle2020/${fileName}`



// WEBPACK FOOTER //
// ./src/utils/index.js